import gql from "graphql-tag";

export default gql`
  mutation UpdateUser($userInput: UserInputInput, $customerId: ID, $username: ID) {
    updateUser(userInput: $userInput, customerId: $customerId, username: $username) {
      id
      username
    }
  }
`;
